import { Box, Chip, Paper, Typography, useTheme } from "@mui/material";
import { SquareArrowRightUp } from "@solar-icons/react/ssr";

/**
 * LinksPanel — displays tool-generated URLs from the conversation.
 *
 * Props:
 *  - links: Array<{ name, type, url }>
 */
export default function LinksPanel({ links = [] }) {
    const theme = useTheme();

    if (links.length === 0) return null;

    return (
        <Paper
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: 3,
                background: theme.palette.background.default,
                overflow: "hidden",
                p: 2,
            }}
        >
            <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ mb: 1 }}
            >
                Links
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    overflow: "auto",
                }}
            >
                {links.map((link, index) => (
                    <Chip
                        component="a"
                        key={index}
                        label={
                            link.name
                                ? link.type
                                    ? `${link.type}: ${link.name}`
                                    : link.name
                                : link.url
                        }
                        href={link.url}
                        target="_blank"
                        clickable
                        icon={<SquareArrowRightUp size={18} />}
                    />
                ))}
            </Box>
        </Paper>
    );
}
